<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="dialogTitle" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" class="userFrom">
                    <el-col :span="12">
                        <el-form-item :label="t('field.realName')" prop="real_name">
                            <span>{{ state.form.real_name }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="state.form.title">
                        <el-form-item :label="t('detail.deviceLabel')" prop="title">
                            <span>{{ state.form.title }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="state.form.project_location_name">
                        <el-form-item :label="t('attendance.projectSite')" prop="project_location_name">
                            <span>{{ state.form.project_location_name }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.workContent')" prop="contents">
                            <span>{{ state.form.contents }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('detail.clockTime')" prop="checkin_time">
                            <span>{{ state.form.checkin_time }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.clockType')" prop="source">
                            <span>{{ state.form.source }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.shiftType')" prop="shift_type">
                            <span>{{ (state.form.shift_type === 2 || state.form.shift_type === '夜班') ? t('attendance.nightShift') : t('attendance.dayShift') }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('field.mobile')" prop="mobile">
                            <span>{{ state.form.mobile }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.longitude')" prop="longitude">
                            <span>{{ state.form.longitude }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.latitude')" prop="latitude">
                            <span>{{ state.form.latitude }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('attendanceDialog.relatedPhotos')" prop="status">
                            <div>
                                <hc-oss-image-list :value="state.form.url" />
                            </div>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('improveDetail.close') }}</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, defineEmits, defineProps, defineExpose, computed } from "vue";
import { usePageI18n, t } from "@/composables/usePageI18n.js";
import { formatDisplayDateTime } from "@/utils/dateTime.js";

const emit = defineEmits([]);
const props = defineProps({
    title: { type: String, default: '' },
});

const dialogTitle = computed(() => props.title || t('attendanceDialog.recordDetailTitle'));

const state = reactive({
    dialogVisible: false,
    form: {},
});

const open = (row = {}) => {
    if (row?.id) {
        state.form = {
            ...row,
            checkin_time: formatDisplayDateTime(row.checkin_time) || "-",
        };
    }
    state.dialogVisible = true;
};

usePageI18n(() => {});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}
.userFrom {
    display: grid;
    gap: 20px;
}
.el-form-item {
    margin-bottom: 0;
}
.record-img {
    width: 120px;
    height: 120px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
